module.exports = __webpack_public_path__ + "img/abouts.6f4e29c4.png";